import get from 'lodash/get';
import { useQuery } from '../../../tools/useQuery';
import GET_PROVIDER_DEMOGRAPHICS from './GetProviderDemographics.gql';

const parseResult = (result) => {
  const initialState = {};

  const providerDemographicsResponse = get(
    result,
    'core.getProviderDemographics'
  );
  return {
    ...initialState,
    ...providerDemographicsResponse,
  };
};

export const useProviderDemographicsQuery = (options) => {
  const [queryResult, queryAction] = useQuery(GET_PROVIDER_DEMOGRAPHICS, {
    ...options,
    onCompleted: (result) => {
      if (options.onCompleted) {
        options.onCompleted(parseResult(result.body.data));
      }
    },
  });
  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
